module.exports = __webpack_public_path__ + "static/img/custom-logo.b17e4d4e.png";